import {ENV} from '../utils';

export class AdminPermissionAPI {
    basePath = ENV.BASE_PATH;

    // get adminPermissions
    async getPermissions(accessToken,statusRequest) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSIONS}?status=${statusRequest}`;
            console.log(url);
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    async getPermissionById(accessToken, idPermission) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSION}/${idPermission}`;
            console.log(url);
            const params = {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error);
            throw error
        }
    }

    async updatePermission(accessToken, idPermission, permissionData) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSION}/${idPermission}`
            console.log(url);
            const params = {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify(permissionData)
            };

            const response = await fetch(url, params);
            const result = await response.json()

            if(response.status !== 200) throw result;
            return result;
                        
        } catch (error) {
            console.log(error);
            throw error;
        }
    }

    async approvePermission(accessToken, idPermission) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSION}/${idPermission}${ENV.API_ROUTES.APPROVE_PERMISSION}`
            console.log(url)
            const params = {
                method : "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }

            const response = await fetch(url, params);
           // const result = await response.json();
            const result = {}
            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }

    async deletePermission(accessToken, idPermission) {
        try {
            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSION}/${idPermission}`;
            console.log(url)
            const params = {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                },
            };
            
            const response = await fetch(url, params);
            // const result = await response.json();
            const result ={}

            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }

    async sendOtpPermission(accessToken, idPermission) {
        try {

            const url = `${this.basePath}${ENV.API_ROUTES.PERMISSION}/${idPermission}${ENV.API_ROUTES.OTP_PERMISSION}`
            console.log(url)
            const params = {
                method : "PUT",
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            }

            const response = await fetch(url, params);
           // const result = await response.json();
            const result = {}
            if(response.status !== 200) throw result;
            return result;

        } catch (error) {
            console.log(error)
            throw error
        }
    }
}